import React from 'react';
import { insertRecaptcha } from'../../utils';

const Recaptcha = (
    {
        children,
        action,
        onSubmit,
        recaptchaInputId = 'g-recaptcha-response',
        recaptchaInputName = 'g-recaptcha-response'
    }
) => {

    const handleSubmit = () => {
        window.grecaptcha.ready(function() {
            window.grecaptcha.execute(
                window.recaptcha_site_key, { action }
            )
            .then(recaptchaToken => {
                document.getElementById(recaptchaInputId).value = recaptchaToken;
                onSubmit(recaptchaToken);
            });
        });
    };

    React.useEffect(() => {
        const script = insertRecaptcha(true, false);
        return () => {
            document.getElementsByTagName("head")[0].removeChild(script);
        }
    }, []);

    return (
        <>
            <input
                type="hidden"
                id={recaptchaInputId}
                name={recaptchaInputName}
            />
            {
                children({
                    submitAction: handleSubmit
                })
            }
        </>
    );
};

export default Recaptcha;